import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet, ScrollView } from '@usepepper/sprout-kit-ui';

interface AccountDetailHoursSheetProps {
  children: React.ReactElement;
  isVisible: boolean;
  onClose: () => void;
}

const SNAP_POINTS = [50];

export const AccountDetailHoursSheet: React.FC<
  AccountDetailHoursSheetProps
> = ({ children, isVisible, onClose }) => (
  <ActionSheet
    onOpenChange={(open) => {
      if (!open) {
        onClose();
      }
    }}
    open={isVisible}
    snapPoints={SNAP_POINTS}
  >
    <ActionSheet.Header marginBottom="$8" paddingBottom={0}>
      <ActionSheet.Title
        color="$textPrimary"
        fontSize="$xl"
        fontWeight="$medium"
      >
        {i18n.t('sales_portal.account_detail.hours.title')}
      </ActionSheet.Title>
    </ActionSheet.Header>
    <ActionSheet.Body>
      <ScrollView showsVerticalScrollIndicator={false}>{children}</ScrollView>
    </ActionSheet.Body>
  </ActionSheet>
);
